import { gql } from 'graphql-request'
import { createQuery } from '@fivehealth/botero'

const GRAPHQL_DOCUMENT = gql`
  mutation deleteProfilesGroup($input: DeleteEinsteinProfilesGroupInput!) {
    einsteinProfilesGroupDelete(input: $input) {
      deleteMutationResult {
        uid
      }
    }
  }
`

export default createQuery({
  gqlDocument: GRAPHQL_DOCUMENT,
  queryType: 'mutation',
  baseQueryKey: 'profilesGroupDelete',
  keepPreviousData: false,
})
